import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

(async () => {
  await msalInstance.initialize();

  const arcgisCss = document.createElement('link');
  arcgisCss.rel = 'stylesheet';
  arcgisCss.href = 'https://js.arcgis.com/4.34/esri/themes/light/main.css';
  document.head.appendChild(arcgisCss);

  /*
  const calciteCss = document.createElement('link');
  calciteCss.rel = 'stylesheet';
  calciteCss.href = 'https://js.arcgis.com/calcite-components/3.3.3/calcite.css';
  document.head.appendChild(calciteCss);
   */
  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MsalProvider>
  );
})();
